require('../../../Resources/OneBidSiteBundle/public/js/masonry.pkgd.min.js');
require('../../../Resources/OneBidSiteBundle/public/js/listing.js');

